const wait = (ms: number): Promise<never> =>
  new Promise((r) => setTimeout(r, ms));

export default wait;
